import Section from '../components/ui/Section';
import blogPosts from '../data/blogPosts';
import BlogPostCard from '../components/BlogPostCard';
import NavBar from '../components/NavBar'; // Added NavBar import
import { useEffect } from 'react';
import ReactGA from "react-ga4";

const Blog = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/blog-home",
      title: "Blog Homepage",
    });
  });
  return (
    <> {/* Added Fragment */}
      <NavBar /> {/* Added NavBar */}
      <Section className="py-12 pt-32"> {/* Adjusted padding-top */}
        <div className="container mx-auto px-4">
          <div className="text-center mb-20">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900 leading-tight">
              <span className="bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
                  TravelMaker
                </span> Blog
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              All about travel, product and engineering with TravelMaker
            </p>
          </div>
          <div className="flex flex-col items-center gap-8">
            {blogPosts
              .filter((post) => post.isPublished)
              .map((post) => (
                <BlogPostCard key={post.id} post={post} />
              ))}
          </div>
        </div>
      </Section>
    </> // Added Fragment
  );
};

export default Blog;
